import {
  InformationTypography,
  DirectionContainer,
  PaddingContainer,
  RootDiv,
  TitleTypography,
  InlineContainer,
} from '../styles/DeliveryDetails.styles';
import {
  formatAddress,
  extractShortDate,
  withoutTimezone,
  getWeekdayName,
} from '@utils';
import { Address, DeliveryType } from '@interfaces';
import { DivisionLine } from '../styles/ProductsList.styles';
import { useCurrentOrderLoadingStore } from '../zustand/currentOrderStore';
import { SkeletonTotalPriceText } from '@screens/checkout/paymentMethod/styles/PaymentFooter.styles';
import { Fragment } from 'react';
import { usePermissions } from '@hooks/usePermissions';

interface DeliveryDetailsProps {
  deliveryDatesAndProductsAmount: { date: string; productAmount: number }[];
  address: Address;
  deliveryType: DeliveryType;
}
export function DeliveryDetails(props: DeliveryDetailsProps) {
  const { deliveryDatesAndProductsAmount, address, deliveryType } = props;

  const { userCan } = usePermissions();
  const isLocalVendor = userCan('LOCAL_VENDOR');

  const { loadingCurrentOrder } = useCurrentOrderLoadingStore();
  const firstDate = (deliveryDatesAndProductsAmount || [])[0]?.date.replace(
    /-/g,
    '/',
  );
  return (
    <RootDiv>
      <TitleTypography>
        Detalle {deliveryType == 'PICK_UP' ? 'retiro' : 'entrega'}
      </TitleTypography>
      <DivisionLine />
      <PaddingContainer>
        {loadingCurrentOrder || deliveryDatesAndProductsAmount?.length == 1 ? (
          <InlineContainer>
            <InformationTypography>
              <span>{deliveryType == 'PICK_UP' ? 'Retiro:' : 'Entrega:'}</span>
              {loadingCurrentOrder && <SkeletonTotalPriceText />}

              {deliveryDatesAndProductsAmount && (
                <Fragment>
                  {loadingCurrentOrder ? (
                    <SkeletonTotalPriceText />
                  ) : (
                    <>
                      {getWeekdayName(firstDate)}{' '}
                      {extractShortDate(withoutTimezone(new Date(firstDate)))}
                    </>
                  )}
                </Fragment>
              )}
            </InformationTypography>
          </InlineContainer>
        ) : (
          <>
            <InformationTypography>
              <span>{deliveryType == 'PICK_UP' ? 'Retiros' : 'Entregas'}</span>
            </InformationTypography>
            {deliveryDatesAndProductsAmount?.map((values, index) => {
              return (
                <InformationTypography key={index}>
                  · {values.productAmount} producto
                  {values.productAmount > 1 && 's'} el
                  {` ${getWeekdayName(
                    values.date.replace(/-/g, '/'),
                  )} ${extractShortDate(
                    withoutTimezone(new Date(values.date.replace(/-/g, '/'))),
                  )}`}
                </InformationTypography>
              );
            })}
          </>
        )}

        <DirectionContainer>
          <InformationTypography>
            <span>Dirección:</span>
            {loadingCurrentOrder ? (
              <>
                <SkeletonTotalPriceText />
              </>
            ) : (
              <>
                {deliveryType == 'PICK_UP' || isLocalVendor
                  ? 'Av. El Salto 4001, Local 8, Huechuraba'
                  : formatAddress(address)}
              </>
            )}
          </InformationTypography>
        </DirectionContainer>
        {deliveryType == 'PICK_UP' && (
          <DirectionContainer>
            <InformationTypography>
              <span>Horario de atención: </span>Lunes a Viernes de 09:00 a 18:00
              hrs
            </InformationTypography>
          </DirectionContainer>
        )}
      </PaddingContainer>
    </RootDiv>
  );
}
